import styles from './PictureBox.module.scss'

const PictureBox: React.FC = () => {
  return (
    <>
      <section className={styles.pictureWrapper}>
        <div className={styles.lineText}>
          <p className={styles.marquee}>Business Design Technology</p>
        </div>
        <div>
          <div className={`${styles.redBox} ${styles.Left}`}></div>
          <div className={`${styles.redBox} ${styles.Right}`}></div>
          <img className={styles.imgLeft} src="/images/lp2/gallery_img_1.png" alt="gallery" />
          <img className={styles.imgRight} src="/images/lp2/gallery_img_2.webp" alt="gallery" />
        </div>
      </section>
    </>
  )
}

export default PictureBox
